import { Link } from 'react-router-dom';
import { ArrowRight, Quote } from 'lucide-react';
import { getCaseStudies, CASE_STUDY_CATEGORIES } from '@/data/caseStudies';
import { useLiveTick } from '@/lib/liveContent';
import { Reveal } from '../Reveal';

export const CaseTestimonial = () => {
  // Use the verified testimonial attached to a published case study.
  useLiveTick();
  const source = getCaseStudies().find((cs) => cs.status === 'published' && cs.testimonial);
  if (!source) return null;
  const t = source.testimonial;
  const cat = CASE_STUDY_CATEGORIES[source.categories[0]];

  return (
    <section aria-labelledby="case-testimonial-heading" data-testid="case-testimonial-section" className="bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-4xl px-4 sm:px-6">
        <Reveal>
          <div className="text-center">
            <p className="flex items-center justify-center gap-3">
              <span className="font-mono text-xs font-medium tracking-widest text-gold-700">04</span>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold-700">Client feedback</span>
            </p>
            <h2 id="case-testimonial-heading" className="mt-4 text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
              What it’s like to work with Amden
            </h2>

            <figure className="mt-12 rounded-2xl border border-slate-200 bg-mist p-8 sm:p-12" data-testid="case-testimonial-card">
              <Quote className="mx-auto h-9 w-9" style={{ color: cat.color }} aria-hidden="true" />
              <blockquote className="mx-auto mt-6 max-w-3xl font-serif text-lg font-medium italic leading-relaxed text-navy-800 sm:text-xl">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-7">
                <span className="block text-base font-bold text-navy-900">{t.name}</span>
                {t.position && <span className="mt-0.5 block text-sm font-medium text-slate-500">{t.position}</span>}
                <span className="mt-0.5 block text-sm font-medium text-slate-500">{t.company}</span>
              </figcaption>
              <Link
                to={`/case-studies/${source.slug}`}
                data-testid="case-testimonial-link"
                className="group mt-7 inline-flex items-center gap-2 text-sm font-bold transition-colors"
                style={{ color: cat.dark }}
              >
                Read the {source.client} case study
                <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
              </Link>
            </figure>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
